import logo from "../../assets/logo.png";

function Home() {

    const user =
        JSON.parse(localStorage.getItem("user"));

    return (

        <div
            style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#ffffff"
                //background:
                //    "linear-gradient(135deg, #74b9ff, #0984e3)"
            }}
        >

            <div
                style={{
                    background: "#ffffff",
                    width: "500px",
                    textAlign: "center"
                }}
            >

                <img
                    src={logo}
                    alt="Logo"
                    style={{
                        width: "120px",
                        marginBottom: "15px"
                    }}
                />

                <h1
                    style={{
                        margin: "10px 0",
                        color: "#1e3a5f",
                        fontFamily: "Verdana"
                    }}
                >
                    CRM Enterprises Pvt Ltd
                </h1>

                <h2
                    style={{
                        marginTop: "5px",
                        color: "#1976d2",
                        fontWeight: "600",
                        fontSize: "22px",
                        fontFamily: "Verdana"
                    }}
                >
                    Sales Tracking System
                </h2>

                <hr
                    style={{
                        margin: "25px 0",
                        border: "none",
                        borderTop: "1px solid #c9e2ff"
                    }}
                />

                <p
                    style={{
                        fontSize: "18px",
                        color: "#333",
                        marginBottom: "10px",
                        fontFamily: "Verdana"
                    }}
                >
                    Welcome <b>{user?.username}</b>
                </p>

                <p
                    style={{
                        color: "#666",
                        fontSize: "15px",
                        fontFamily: "Verdana"
                    }}
                >
                    Please select an option from the menu to continue.
                </p>

            </div>

        </div>
    );
}

export default Home;